import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { KeyboardService } from '../../keyboard/keyboard.service';

@Component({
  selector: 'app-select-autocomplete',
  templateUrl: './select-autocomplete.component.html',
  styleUrls: ['./select-autocomplete.component.sass']
})
export class SelectAutocompleteComponent<T> implements OnInit {

  @Input()
  value: string;

  @Input()
  group: FormGroup;

  @Input()
  config: IFieldConfig;

  @Input()
  filteredResults: T[];

  @Input()
  useCompare: boolean = true;

  @Input()
  typeCes?: TypeCesEnum | undefined;

  @Input()
  compareFn: (o1: any, o2: any) => boolean =
    (o1: any, o2: any) => o1.id == o2.id;

  @Output()
  keyup: EventEmitter<any> = new EventEmitter();

  @Output()
  onSelect: EventEmitter<any> = new EventEmitter();

  keyboardChange: EventEmitter<any> = new EventEmitter<any>();

  blockKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRigh']

  /**
   * @constructor
   * Class constructor
   * @param cd
   */
  constructor(private cd: ChangeDetectorRef,
    public keyboardService: KeyboardService) { }


  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.group.get(this.config.name)?.setValue(event);
      this.keyup.emit(this.group.get(this.config.name)?.value)
    });
  }

  onKeyup(event: KeyboardEvent) {
    if (!this.blockKeys.includes(event.key))
      this.keyup.emit(this.group.get(this.config.name)?.value)
  }

  getOptions() {
    return this.config?.options?.map((it) =>
      this.value ? it[this.value] : it
    ) || []
  }

  displayFn(obj: any): string {
    return obj && obj?.name ? obj.name : typeof (obj) === 'string' ? obj : '';
  }
}
